import React from 'react';

import cx from 'classnames';
import { useAsyncDebounce } from 'react-table';

import { translate } from '~l10n/client';
import { IconButton } from '~shared/components/buttons';
import { IconSearch, IconX } from '~shared/components/icons/standard';

/**
 * useful Search component that can be used anywhere
 * specifically in tables
 */

export const Search = ({
  setQuery,
  name,
  variant = 'default',
  placeholder,
}: {
  setQuery: (val: string) => void;
  // Builds the placeholder as `Search {name}`. Use `placeholder` instead when
  // the label needs a single, fully-formed translation key.
  name?: string;
  variant?: 'modal' | 'default';
  placeholder?: string;
}) => {
  const [value, setValue] = React.useState('');
  const onChange = useAsyncDebounce((value) => {
    setQuery(value || '');
  }, 200);
  const MAX_LENGTH = 255;
  return (
    <div className={'relative w-full'}>
      <div className="absolute top-0 bottom-0 left-0 flex items-center py-2 pl-4 text-grey-600">
        <IconSearch />
      </div>
      <input
        className={cx(
          variant === 'default' && 'bg-grey-50 border-0',
          variant === 'modal' &&
            'bg-white border-1 border-grey-200 border-solid',
          'w-full py-2 pr-12 pl-14 m-0 text-base leading-8 rounded-2 focus:border-cyan-500 outline-none appearance-none'
        )}
        type="text"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={placeholder ?? translate('Search {0}').format(name ?? '')}
        maxLength={MAX_LENGTH}
      />
      {value.length > 0 && (
        <div
          className={'absolute right-0'}
          style={{ top: '50%', transform: 'translateY(-50%)' }}
        >
          <IconButton
            withAltBackground={true}
            appearance={'ghost'}
            onClick={() => {
              setValue('');
              setQuery('');
              onChange('');
            }}
          >
            <IconX />
          </IconButton>
        </div>
      )}
    </div>
  );
};
